import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { REACT_APP_API_URL } from "./constants/dev";

export default function NotificationSubscribeInput() {
  const [value, setValue] = useState("");
  const [errorCode, setErrorCode] = useState(0);

  const handleChange = (event) => {
    setValue(event.target.value);
    setErrorCode(0);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetch(`${REACT_APP_API_URL}/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: value }),
    }).then((response) => {
      if (response.status === 200) window.location.reload();
      else if (response.status === 400) setErrorCode(1);
      else if (response.status === 500) setErrorCode(2);
    });
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Typography sx={{ textAlign: "center" }}>
          Please enter your email to subscribe to wedding updates.
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            label="Enter your email."
            value={value}
            onChange={handleChange}
            variant="outlined"
            sx={{
              width: "40vw",
              "& .MuiOutlinedInput-root": {
                color: "rgb(80, 97, 117)", // text color
                "& fieldset": {
                  borderColor: "rgb(80, 97, 117)", // default border
                },
                "&:hover fieldset": {
                  borderColor: "rgb(80, 97, 117)", // hover border
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgb(80, 97, 117)", // focused border
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgb(80, 97, 117)", // label color
                "&.Mui-focused": {
                  color: "rgb(80, 97, 117)", // focused label color
                },
              },
              "& .MuiFormHelperText-root": {
                color: "rgb(80, 97, 117)", // helper text color
              },
            }}
          />
          <Button
            type="submit"
            variant="outlined"
            color="inherit"
            sx={{ margin: "1rem" }}
          >
            Subscribe
          </Button>
        </div>
        {
          errorCode === 1 ?
            <Typography
              sx={{
                textAlign: "center",
                color: "rgb(80, 97, 117)",
                fontFamily: "Pinyon",
              }}
            >
              Hmm, that doesn't look like a valid email.<br/>Could you double-check?
            </Typography> :
            errorCode === 2 ?
              <Typography
                sx={{
                  textAlign: "center",
                  color: "rgb(80, 97, 117)",
                  fontFamily: "Pinyon",
                }}
              >
                Something went wrong.<br/>Try reloading the page or contact the couple.
              </Typography> : null
        }
      </form>
    </Box>
  );
}
